import { DemService } from './../../../../services/demService/dem.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-dem',
  templateUrl: './delete-dem.component.html',
  styleUrls: ['./delete-dem.component.css']
})
export class DeleteDemComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
     private dialog: MatDialog,
     private demService: DemService
     ) { }

  ngOnInit(): void {
    //
  }
  deleteFile() {
    this.demService.deleteDem(this.data.id).subscribe((res: any) => {
      this.demService.deleteDemList(this.data.id)
      this.close()
    })
  }


  close(): void {
    this.dialog.closeAll();
  }
}
